// StrategyModal.js
import React from 'react';

function StrategyModal({ open, onClose }) {
  if (!open) return null;
  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
      background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center'
    }}>
      <div style={{
        background: '#fff', padding: '32px', borderRadius: '12px', minWidth: '350px', maxWidth: '90vw',
        boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
      }}>
        <h1 style={{ fontSize: '24px', fontWeight: 600 }}>선택 전략 Pool 설명</h1>
        <hr></hr>
        <img src="/images/AI추천과정.png" alt="Strategy Pool" style={{ width: '100%', marginTop: '16px', borderRadius: '8px' }} />
        <div style={{display: 'flex', justifyContent: 'flex-end'}}>     
            <button onClick={onClose} style={{
            marginTop: '16px', padding: '6px 18px', borderRadius: '6px', background: '#007bff', color: '#fff', border: 0
            }}>닫기</button>
        </div>
      </div>
    </div>
  );
}

export default StrategyModal;
